import React from 'react';
import { TouchableOpacity, Text, StyleSheet, TouchableOpacityProps, ActivityIndicator } from 'react-native';
import { useThemeColor } from '@/hooks/useThemeColor';

interface PrimaryButtonProps extends TouchableOpacityProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export default function PrimaryButton({ title, onPress, disabled = false, loading = false, style, ...props }: PrimaryButtonProps) {
  const primaryColor = useThemeColor({}, 'primary');
  const textInverseColor = useThemeColor({}, 'textInverse');
  const neutral200Color = useThemeColor({}, 'neutral200');
  const textSecondaryColor = useThemeColor({}, 'textSecondary');
  const blackColor = '#151515';

  // Determine background color: black when loading, gray when disabled (not loading), primary otherwise
  const getBackgroundColor = () => {
    if (loading) return blackColor;
    if (disabled) return neutral200Color;
    return primaryColor;
  };

  return (
    <TouchableOpacity 
      style={[
        styles.button,
        { backgroundColor: getBackgroundColor() },
        style
      ]} 
      onPress={disabled || loading ? undefined : onPress}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <ActivityIndicator color="#FFFFFF" size="small" />
      ) : (
        <Text style={[
          styles.buttonText,
          { color: disabled ? textSecondaryColor : textInverseColor }
        ]}>
          {title}
        </Text>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    borderRadius: 16,
    paddingVertical: 12,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    height: 56,
    width: '100%',
  },
  buttonText: {
    fontSize: 14,
    fontFamily: 'Inter_500Medium',
    lineHeight: 20,
    textAlign: 'center',
    fontWeight: '500',
  },
});